import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"

export function RegimeDraftLockHide({ children }) {
    const { isRegimeDraftLocked } = useBoundContext()
    return <If truthy={!isRegimeDraftLocked}>{children}</If>
}
